var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EditView'),(_vm.$route.params.serveType == 1)?_c('OfficeCollect',{staticClass:"mt20"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }